module.exports = __webpack_public_path__ + "static/media/a57.87dc3d93.jpg";